import React, { useState } from "react";
import { exit_icon } from "../icons/exit";
import Client from "../utils/client";
import { useAuth } from "../store/authProvider";

const PlaceOrderModal = ({ item, setShowOrderModal, negotiationType, tradeType }) => {
  const { isAuth } = useAuth();
  const [quantity, setQuantity] = useState(""); // State for quantity
  const [loading, setLoading] = useState(false); // State for loading status
  const [error, setError] = useState(null); // State for error handling

  const handlePlaceOrder = async () => {
    if (!isAuth) {
      setError("Please log in to place an order.");
      return;
    }

    if (!quantity || isNaN(quantity) || parseInt(quantity) <= 0) {
      setError("Please enter a valid quantity.");
      return;
    }

    setLoading(true);
    setError(null);

    try {
      // Initiate or retrieve an active negotiation
      const response = await Client.post("/negotiations", {
        tradeType: tradeType,
        negotiationType: negotiationType,
        itemId: item.id, // The ID of the Item being negotiated
        quantity: parseInt(quantity), // Convert quantity to a number
      });

      const negotiationId = response.data.id; // Get the negotiation ID from the response

      // Redirect the user to the negotiation page
      window.location.href = `/home/negotiation/${negotiationId}`;

      // Close the modal
      setShowOrderModal(false);
    } catch (err) {
      setError("Failed to place order. Please try again.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none">
        <div className="relative max-w-3xl w-[350px] mx-auto my-6">
          <div className="relative flex flex-col w-full bg-white border-[3px] border-primary rounded-3xl shadow-lg outline-none focus:outline-none p-6">
            <div
              className="text-red-600 w-8 cursor-pointer"
              onClick={() => setShowOrderModal(false)}
            >
              {exit_icon}
            </div>

            <h2 className="text-center font-bold text-xl mb-4">
            {tradeType === "Demand" ? "طلب عرض سعر" : " تقديم عرض"}
            </h2>

            {error && (
              <div className="text-red-500 text-sm mb-3 text-center">{error}</div>
            )}

            <div className="flex flex-col gap-3 text-center">
              <label htmlFor="quantity" className="font-medium text-gray-700">
            
              {negotiationType === "Service" ? (tradeType === "Demand" ? " " : " ") : (tradeType === "Demand" ? "الرجاء كتابة الكمية المطلوبة" : " الرجاء كتابة الكمية المتوفرة ")}
              </label>
              <input
                type="number"
                id="quantity"
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="w-full border border-gray-300 rounded-lg px-4 py-2 text-right"
                placeholder={tradeType === "Demand" ? "الرجاء كتابة الكمية المطلوبة" : " الرجاء كتابة الكمية المتوفرة "}
              />
            </div>

            <button
              onClick={handlePlaceOrder}
              disabled={loading}
              className={`mt-6 w-full py-2 px-4 text-white font-bold rounded-lg ${loading
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-primary hover:bg-primary-dark"
                }`}
            >
              {loading ? "جاري تقديم الطلب..." : "إرسال"}
            </button>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black/30 backdrop-blur-sm"></div>
    </>
  );
};

export default PlaceOrderModal;
